import { getLanguagePair, getUiLocaleForNative } from '@/config/languages';

const IMMERSION_ROUTES = new Set([
  '/home',
  '/dashboard',
  '/review',
  '/library',
  '/create',
  '/feedback',
  '/stats',
  '/achievements',
  '/guides',
  '/ear-training',
  '/tutor',
  '/word-pack',
]);

export function isImmersionUiRoute(pathname: string): boolean {
  return IMMERSION_ROUTES.has(pathname) || /^\/review\/[^/]+$/.test(pathname);
}

export function getUiLocaleForRoute(
  pathname: string,
  pairCode: string,
  immersionMode: boolean,
  signedIn: boolean,
): string {
  const pair = getLanguagePair(pairCode);
  if (!pair) return 'en';

  if (signedIn && immersionMode && isImmersionUiRoute(pathname)) {
    return getUiLocaleForNative(pair.targetCode);
  }

  return getUiLocaleForNative(pair.nativeCode);
}
